import { defineStore } from 'pinia';
import { tagService } from '@/services/tagService';

export const useTagStore = defineStore('tag', {
  state: () => ({
    tags: [],
    loading: false,
    loaded: false,
    error: null,
  }),

  getters: {
    tagOptions: (state) =>
      state.tags.map((tag) => ({ value: tag.id, label: tag.name, color: tag.color })),
    tagById: (state) => (id) => state.tags.find((tag) => tag.id === id) || null,
  },

  actions: {
    async fetchTags({ force = false } = {}) {
      if (this.loaded && !force) return this.tags;

      this.loading = true;
      this.error = null;
      try {
        const data = await tagService.getTags();
        this.tags = data.tags || data || [];
        this.loaded = true;
        return this.tags;
      } catch (error) {
        this.error = error.message;
        throw error;
      } finally {
        this.loading = false;
      }
    },

    async createTag(tagData) {
      try {
        const tag = await tagService.createTag(tagData);
        this.tags.push(tag);
        return tag;
      } catch (error) {
        this.error = error.message;
        throw error;
      }
    },

    async updateTag(tagId, tagData) {
      try {
        const updated = await tagService.updateTag(tagId, tagData);
        const index = this.tags.findIndex((tag) => tag.id === tagId);
        if (index !== -1) {
          this.tags[index] = { ...this.tags[index], ...updated };
        }
        return updated;
      } catch (error) {
        this.error = error.message;
        throw error;
      }
    },

    async deleteTag(tagId) {
      try {
        await tagService.deleteTag(tagId);
        this.tags = this.tags.filter((tag) => tag.id !== tagId);
      } catch (error) {
        this.error = error.message;
        throw error;
      }
    },
  },
});

export default useTagStore;
